module.exports = __webpack_public_path__ + "static/media/logo-new.81b7a28c.png";